// src/actions/submission_schedules.js

import api from './gamba-api'
import { emitAlertMessage } from './alert-message'

export const SAVE_SUBMISSION_SCHEDULES = "SAVE_SUBMISSION_SCHEDULES"
export const SAVE_SUBMISSION_SCHEDULES_REQUESTED = "SAVE_SUBMISSION_SCHEDULES_REQUESTED"
export const SAVE_SUBMISSION_SCHEDULES_COMPLETED = "SAVE_SUBMISSION_SCHEDULES_COMPLETED"
export const SAVE_SUBMISSION_SCHEDULES_FAILED = "SAVE_SUBMISSION_SCHEDULES_FAILED"

export function saveSubmissionSchedulesRequested() {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_REQUESTED
  }
}

export function saveSubmissionSchedules(group_id, start_date, end_date, schedules, user_id) {
  return function(dispatch) {
    dispatch(saveSubmissionSchedulesRequested())
    return api.put(`/submission_schedules`, {group_id, start_date, end_date, schedules, user_id})
      .then((results) => {
        dispatch(saveSubmissionSchedulesCompleted(results))
      })
      .catch((error) => {
        Promise.all([
          dispatch(saveSubmissionSchedulesFailed(error)),
          dispatch(emitAlertMessage(error, 'error'))
        ])
      })
  }
}

export function saveSubmissionSchedulesCompleted(results) {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_COMPLETED,
    results,
  }
}

export function saveSubmissionSchedulesFailed(error) {
  return {
    type: SAVE_SUBMISSION_SCHEDULES_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/submission-schedules.js